import { render } from "./TwoFactorAuth.vue?vue&type=template&id=6c99aebd&scoped=true"
import script from "./TwoFactorAuth.vue?vue&type=script&lang=js"
export * from "./TwoFactorAuth.vue?vue&type=script&lang=js"

import "./TwoFactorAuth.vue?vue&type=style&index=0&id=6c99aebd&scoped=true&lang=css"

import exportComponent from "C:\\repo\\ono\\ops-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c99aebd"]])

export default __exports__